import { PERMISSIONS } from '@savgroup-front-common/constants/src/control';
import { useHasPermission } from '@savgroup-front-common/core/src/hooks';

const useHasBusinessIntelligencePermission = (): boolean => {
  return useHasPermission(PERMISSIONS.VIEW_ANALYTICS);
};

export default useHasBusinessIntelligencePermission;
